import { render, staticRenderFns } from "./PosReportEventMembers.vue?vue&type=template&id=58b8c581&"
import script from "./PosReportEventMembers.vue?vue&type=script&lang=js&"
export * from "./PosReportEventMembers.vue?vue&type=script&lang=js&"
import style0 from "./PosReportEventMembers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports